function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".facebook_svg__cls-1{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "facebook_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "facebook_svg__Icons"
}, /*#__PURE__*/React.createElement("path", {
  className: "facebook_svg__cls-1",
  d: "M41 82a41 41 0 1141-41 41 41 0 01-41 41zm0-80a39 39 0 1039 39A39 39 0 0041 2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "facebook_svg__cls-1",
  d: "M32.32 34.9H36v-3.61c0-1.6 0-4.06 1.2-5.58A6.62 6.62 0 0143 23a23.38 23.38 0 016.67.67l-.93 5.51a12.54 12.54 0 00-3-.45c-1.45 0-2.74.52-2.74 2v4.17h5.94l-.41 5.39H43V59h-7V40.29h-3.68z"
})));

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 82"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4MiA4MiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5GYWNlYm9vazwvdGl0bGU+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9Ikljb25zIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik00MSw4MkE0MSw0MSwwLDEsMSw4Miw0MSw0MSw0MSwwLDAsMSw0MSw4MlpNNDEsMkEzOSwzOSwwLDEsMCw4MCw0MSwzOSwzOSwwLDAsMCw0MSwyWiIvPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTMyLjMyLDM0LjlIMzZWMzEuMjljMC0xLjYsMC00LjA2LDEuMi01LjU4QTYuNjIsNi42MiwwLDAsMSw0MywyM2EyMy4zOCwyMy4zOCwwLDAsMSw2LjY3LjY3bC0uOTMsNS41MWExMi41NCwxMi41NCwwLDAsMC0zLS40NWMtMS40NSwwLTIuNzQuNTItMi43NCwyVjM0LjloNS45NGwtLjQxLDUuMzlINDNWNTlIMzZWNDAuMjlIMzIuMzJaIi8+PC9nPjwvZz48L3N2Zz4=";
export { SvgFacebook as ReactComponent };